module.exports = __webpack_public_path__ + "media/images/pic/banners/online-learning-e14650e8aaa9b403174d7f0846231d7e.jpeg";